module.exports = "tr{\n    height:55px;\n}"